<template id="report">
  <div>
    <datepicker label="Datum" v-model="report.date"></datepicker>
    <vx-card class="mt-base">
    <div class="vx-row w-full">
    <vs-divider>
      <h4>IZPLAČILO</h4>
    </vs-divider>
      <div class="vx-col w-1/2">
      <ReportIzplacila :report="report" vvFormScope="reportIzplacila"></ReportIzplacila>
      </div>
      <div class="vx-col w-1/2">
      <ReportIzplacila2 :report="report" vvFormScope="reportIzplacila2"></ReportIzplacila2>
      </div>
    </div>
    </vx-card>
    <vx-card class="mt-base">
    <div class="vx-row w-full">
    <vs-divider>
      <h4>POLNITEV</h4>
    </vs-divider>
      <div class="vx-col w-1/2">
      <ReportPolnitev :report="report" vvFormScope="reportPolnitev"></ReportPolnitev>
      </div>
      <div class="vx-col w-1/2">
      <ReportPolnitev2 :report="report" vvFormScope="reportPolnitev2"></ReportPolnitev2>
      </div>
    </div>
    <vs-divider>
              <h4>Nakazilo na TRR: {{((report.report010.amount*report.report010.value)+
                             (report.report020.amount*report.report020.value)+
                             (report.report050.amount*report.report050.value)+
                             (report.report1.amount*report.report1.value)+
                             (report.report2.amount*report.report2.value)+
                             (report.report5.amount*report.report5.value)+
                             (report.report10.amount*report.report10.value)+
                             (report.report20.amount*report.report20.value)+
                             (report.report50.amount*report.report50.value)-
                             (report.reportp010.amount*report.reportp010.value)-
                             (report.reportp020.amount*report.reportp020.value)-
                             (report.reportp050.amount*report.reportp050.value)-
                             (report.reportp1.amount*report.reportp1.value)-
                             (report.reportp5.amount*report.reportp5.value)-
                             (report.reportp10.amount*report.reportp10.value)).toFixed(2) + "€"}}</h4>
    </vs-divider>
    </vx-card>
    <vs-textarea label="Note" class="mt-base" v-model="report.note"></vs-textarea>
  </div>
</template>
<script>
import ReportItem from './ReportTemplate1Item.vue'
import ReportIzplacila from './ReportTemplate1Izplacila.vue'
import ReportIzplacila2 from './ReportTemplate1Izplacila2.vue'
import ReportPolnitev from './ReportTemplate1Polnitev.vue'
import ReportPolnitev2 from './ReportTemplate1Polnitev2.vue'
import Datepicker from 'vuejs-datepicker';
export default {
  inject: ["$validator"],
  name: "report-component",
  template: "#report",
  props: {
    report: {
      type: Object
    },
    vvFormScope: {
      type: String
    }
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  components: {
      ReportItem,
      Datepicker,
      ReportIzplacila,
      ReportIzplacila2,
      ReportPolnitev,
      ReportPolnitev2
  }
};
</script>